import React from 'react'
import { connect } from 'react-redux'
import { convertToMeters, convertToSeconds } from 'supporticon/utils/units'
import { selectLocalisation } from '../../../../store/site'

import capitalize from 'lodash/capitalize'
import pluralize from 'pluralize'

import Activity from '../Activity'
import Button from '../../../ui/Button'
import CreateFitnessForm from 'supporticon/components/create-fitness-form'
import Modal from '../../../ui/FlatModal'
import Section from 'constructicon/section'
import Success from '../../../ui/Success'
import Title from '../../../ui/Title'

class CreateFitness extends React.Component {
  constructor () {
    super()
    this.state = {
      data: {},
      modal: false,
      success: false
    }
  }

  handleClose () {
    this.setState({ modal: false, success: false })
  }

  render () {
    const { data, modal, success } = this.state
    const {
      customFitnessType,
      fitnessTypes,
      isCustom,
      onSuccess,
      page,
      token,
      uom
    } = this.props

    const label = isCustom ? `Log ${pluralize(customFitnessType)}` : 'Log fitness'

    return (
      <div>
        <Button onClick={() => this.setState({ modal: true })}>
          {label}
        </Button>
        <Modal
          contentLabel={label}
          isOpen={modal}
          spacing={1.5}
          onRequestClose={() => this.handleClose()}
        >
          {success ? (
            <Success title='Logged successfully'>
              <Section spacing={{ b: 0.5 }}>
                <Activity
                  {...data}
                  activityType='fitness'
                  distance={convertToMeters(data.distance, data.unit)}
                  duration={convertToSeconds(data.duration, data.durationUnit)}
                  elevation={convertToMeters(data.elevation, data.elevationUnit)}
                  customFitnessType={customFitnessType}
                  isCustom={isCustom}
                />
              </Section>
              <Button onClick={() => this.handleClose()}>
                Close
              </Button>
            </Success>
          ) : (
            <div>
              <Title spacing={{ b: 1 }}>{label}</Title>
              <CreateFitnessForm
                pageId={page.id}
                pageSlug={page.slug}
                token={token}
                distanceLabel={isCustom ? capitalize(pluralize(customFitnessType)) : 'Distance'}
                type={fitnessTypes.length === 1 && fitnessTypes[0]}
                types={fitnessTypes}
                includeUnit={!isCustom}
                includeDuration={!isCustom}
                includeElevation={!isCustom}
                includeType={fitnessTypes.length > 1}
                uom={uom}
                submit={label}
                onSuccess={(_, data) =>
                  this.setState({ data, success: true }, () => setTimeout(onSuccess, 1000))
                }
              />
            </div>
          )}
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  ...selectLocalisation(state)
})

export default connect(mapStateToProps)(CreateFitness)
